"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// venues
const generic_1 = __importDefault(require("./generic"));
const heiligendamm_1 = __importDefault(require("./heiligendamm"));
const kronenhof_1 = __importDefault(require("./kronenhof"));
const schloss_elmau_1 = __importDefault(require("./schloss-elmau"));
const orania_berlin_1 = __importDefault(require("./orania-berlin"));
const schwabinger_wahrheit_1 = __importDefault(require("./schwabinger-wahrheit"));
const beyond_by_geisel_1 = __importDefault(require("./beyond-by-geisel"));
const excelsior_by_geisel_1 = __importDefault(require("./excelsior-by-geisel"));
const dorfhotel_boltenhagen_1 = __importDefault(require("./dorfhotel-boltenhagen"));
const kralleralm_1 = __importDefault(require("./kralleralm"));
const asitzbraeu_1 = __importDefault(require("./asitzbraeu"));
const alte_schmiede_1 = __importDefault(require("./alte-schmiede"));
const torfhaus_harzresort_1 = __importDefault(require("./torfhaus-harzresort"));
const pizzeriaDaBruno_1 = __importDefault(require("./pizzeriaDaBruno"));
const mooshaus_1 = __importDefault(require("./mooshaus"));
const alpenroseKutai_1 = __importDefault(require("./alpenroseKutai"));
const louis_c_jacob_1 = __importDefault(require("./louis-c-jacob"));
const upstalsboom_1 = __importDefault(require("./upstalsboom"));
const interalpen_tyrol_1 = __importDefault(require("./interalpen-tyrol"));
// brands
const a_rosa_1 = __importDefault(require("./a-rosa"));
const tui_blue_1 = __importDefault(require("./tui-blue"));
const blue_star_1 = __importDefault(require("./blue-star"));
const tui_on_tour_1 = __importDefault(require("./tui-on-tour"));
const tui_lapland_1 = __importDefault(require("./tui-lapland"));
const tui_magic_life_1 = __importDefault(require("./tui-magic-life"));
const family_life_1 = __importDefault(require("./family-life"));
const gotthard_1 = __importDefault(require("./gotthard"));
const iberotel_1 = __importDefault(require("./iberotel"));
const interalpen_1 = __importDefault(require("./interalpen"));
const robinson_1 = __importDefault(require("./robinson"));
const villa_bulfon_1 = __importDefault(require("./villa-bulfon"));
const vissidarte_1 = __importDefault(require("./vissidarte"));
const sensatori_1 = __importDefault(require("./sensatori"));
const bachmair_weissach_1 = __importDefault(require("./bachmair-weissach"));
const _101_besten_1 = __importDefault(require("./101-besten"));
exports.default = {
    // brands
    arosa: a_rosa_1.default,
    tuiblue: tui_blue_1.default,
    bluestar: blue_star_1.default,
    tuiontour: tui_on_tour_1.default,
    tuilapland: tui_lapland_1.default,
    tuimagiclife: tui_magic_life_1.default,
    familylife: family_life_1.default,
    gotthard: gotthard_1.default,
    iberotel: iberotel_1.default,
    interalpen: interalpen_1.default,
    robinson: robinson_1.default,
    villabulfon: villa_bulfon_1.default,
    vissidarte: vissidarte_1.default,
    sensatori: sensatori_1.default,
    bachmairWeissach: bachmair_weissach_1.default,
    besten: _101_besten_1.default,
    // venues
    interalpenTyrol: interalpen_tyrol_1.default,
    generic: generic_1.default,
    heiligendamm: heiligendamm_1.default,
    kronenhof: kronenhof_1.default,
    elmau: schloss_elmau_1.default,
    oraniaberlin: orania_berlin_1.default,
    schwabingerwahrheit: schwabinger_wahrheit_1.default,
    beyondbygeisel: beyond_by_geisel_1.default,
    excelsiorbygeisel: excelsior_by_geisel_1.default,
    dorfhotelboltenhagen: dorfhotel_boltenhagen_1.default,
    kralleralm: kralleralm_1.default,
    asitzbraeu: asitzbraeu_1.default,
    alteschmiede: alte_schmiede_1.default,
    torfhausharzresort: torfhaus_harzresort_1.default,
    pizzeriaDaBruno: pizzeriaDaBruno_1.default,
    mooshaus: mooshaus_1.default,
    alpenroseKutai: alpenroseKutai_1.default,
    louiscjacob: louis_c_jacob_1.default,
    upstalsboom: upstalsboom_1.default,
};
